export default "__VITE_ASSET__dakNtZTg__"